// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@awc/App/SharedStyles/CartLineSharedStyles";
import { savedOrderDetailsCartLineStyles } from "@awc/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

savedOrderDetailsCartLineStyles.savedOrderLineCardAddToListLink = {
    ...mergeWithCss(cartLineSharedStyles.addToListLink, {
        css: css`
            margin-top: 12px;
        `,
    }),
};

savedOrderDetailsCartLineStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};

savedOrderDetailsCartLineStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

savedOrderDetailsCartLineStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

savedOrderDetailsCartLineStyles.productPrice = {
    ...cartLineSharedStyles.productPrice,
};

savedOrderDetailsCartLineStyles.productAvailability = {
    ...cartLineSharedStyles.productAvailability,
};

savedOrderDetailsCartLineStyles.cartLineErrorMessageText = {
    ...cartLineSharedStyles.errorMessage,
};

savedOrderDetailsCartLineStyles.extendedUnitNetPrice = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
};

savedOrderDetailsCartLineStyles.cartLineContainerStyles = {
    image: {
        css: css`
            @media print {
                margin-bottom: 12px;
                float: left;
            }
        `,
    },
    description: {
        css: css`
            @media print {
                min-height: 132px;
                width: calc(100% - 120px);
                float: right;
                padding-left: 12px;
            }
        `,
    },
    price: {
        css: css`
            @media print {
                min-width: 30%;
            }
        `,
    },
    remove: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 1 / 5;
                grid-row: 5 / 6;
                margin-top: 4px;
            }
        `,
    },
    qty: {
        css: css`
            grid-column: 3 / 4;
            grid-row: 2 / 3;
            display: flex;
            justify-content: end;
            @media print {
                min-width: 30%;
                display: block;
                margin-top: 16px;
                text-align: left;
            }
        `,
    },
    total: {
        css: css`
            grid-row: 2 / 3;
            grid-column: 4 / 5;
            @media print {
                min-width: 30%;
                [data-test-selector="heading"] {
                    margin-bottom: 0;
                }
            }
        `,
    },
};

savedOrderDetailsCartLineStyles.cartLineQuantity = {
    qtyLabel: {
        color: "secondary",
    },
    valueText: { lineHeight: fontConfig.lineHeight.xSmall },
} as any;
